import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'app/services/auth.service';
import { Subscription, interval } from 'rxjs';
import { tap } from 'rxjs/operators';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'extend-session',
  templateUrl: './extend-session.component.html',
  styleUrls: ['./extend-session.component.scss'],
})
export class ExtendSessionComponent implements OnInit, OnDestroy {
  private sub: Subscription;

  counter: number;;

  constructor(
    private authService: AuthService,
    private dialog: MatDialogRef<ExtendSessionComponent>,
  ) {}

  ngOnInit(): void {
    this.counter = this.getRemaining();
    this.sub = interval(1000)
      .pipe(
        tap(() => {
          const remaining = this.getRemaining();
          this.counter = remaining;
          if (remaining <= 0) {
            this.authService.logout();
          }
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  extendSession() {
    this.authService.checkForLogin().subscribe(() => {
      this.dialog.close();
    });
  }

  private getRemaining() {
    const token = localStorage.getItem(AuthService.authTokenKey);
    const decoded: any = jwtDecode(token);

    return Math.floor(decoded.exp - new Date().valueOf() / 1000);
  }
}
